import Icon from '../Icon.vue'

Icon.register({
  'loading_star': {
    width: 20,
    height: 20,
    paths: [
      {
        d: 'M1 11a1 1 0 110-2h5a1 1 0 110 2H1zM14 11a1 1 0 110-2h5a1 1 0 110 2h-5zM11 6a1 1 0 11-2 0V1a1 1 0 112 0v5zM11 19a1 1 0 11-2 0v-5a1 1 0 112 0v5zM4.343 17.071a1 1 0 11-1.414-1.414l3.535-3.536a1 1 0 111.415 1.415L4.343 17.07zM13.536 7.879a1 1 0 11-1.415-1.415l3.536-3.535a1 1 0 111.414 1.414L13.535 7.88zM7.879 6.464A1 1 0 116.464 7.88L2.93 4.343A1 1 0 114.343 2.93L7.88 6.464zM17.071 15.657a1 1 0 11-1.414 1.414l-3.536-3.536a1 1 0 111.415-1.414l3.535 3.536z'
      }
    ]
  }
})
